import { useTranslation } from 'react-i18next';
import { InfoIcon } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export function SharedLinkTypeTooltip() {
  const { t } = useTranslation();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={t('sharedLinkTypeHelp')}
          className="inline-flex shrink-0 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
          <InfoIcon aria-hidden className="h-3.5 w-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        sideOffset={6}
        className="max-w-xs space-y-2 rounded-lg border border-border/50 p-3 text-left text-sm leading-relaxed text-text-primary shadow-lg"
      >
        <p>
          <strong>{t('view-only')}:</strong> {t('sharedLinkViewOnlyDescription')}
        </p>
        <p>
          <strong>{t('limited')}:</strong> {t('sharedLinkLimitedDescription')}
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
